import { gql } from '@apollo/client';

export const ALL_AUCTION_LIMITS_QUERY_NAME = 'AllAuctionLimits';
export const ALL_AUCTION_LIMITS = gql`
    query ${ALL_AUCTION_LIMITS_QUERY_NAME}(
        $page: Int, 
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
    ) {
        allAuctionLimits(
            page: $page, 
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
        ) {
            availableProducts {
                name
                productId
            }
            availableMembers {
                name
                memberId
            }
            minAuctionLimit
            maxAuctionLimit
            auctionLimitList {
                totalCount
                models {
                    id
                    limit
                    product {
                        productId
                        name
                    }
                    member {
                        memberId
                        name
                    }
                }
            }
        }
    }
`;

export const CREATE_AUCTION_LIMIT = gql`
    mutation CreateAuctionLimit(
        $memberId: String!,
        $productId: String!,
        $limit: Int!,
        $correlationId: String!,
        $extraConfirmation: Boolean = false,
    ) {
        createAuctionLimit(
            memberId: $memberId,
            productId: $productId,
            limit: $limit,
            correlationId: $correlationId,
            extraConfirmation: $extraConfirmation,
        ) {
            member {
                memberId
                name
            }
            product {
                productId
                name
            }
        }
    }
`;

export const UPDATE_AUCTION_LIMIT = gql`
    mutation UpdateAuctionLimit(
        $id: Int!, 
        $limit: Int!,
        $correlationId: String!
        $extraConfirmation: Boolean = false,
    ) {
        updateAuctionLimit(
            id: $id, 
            limit: $limit, 
            correlationId: $correlationId,
            extraConfirmation: $extraConfirmation,
        ) {
            member {
                memberId
                name
            }
            product {
                productId
                name
            }
        }
    }
`;

export const DELETE_AUCTION_LIMIT = gql`
    mutation DeleteAuctionLimit(
        $id: Int!, 
        $correlationId: String!,
    ) {
        deleteAuctionLimit(
            id: $id, 
            correlationId: $correlationId,
        ) {
            member {
                memberId
                name
            }
            product {
                productId
                name
            }
        }
    }
`;

export const ON_AUCTION_LIMIT_CHANGED = gql`
    subscription onAuctionLimitChanged {
        auctionLimitChanged {
            correlationId
            action
            model {
                member {
                    memberId
                    name
                }
                product {
                    productId
                    name
                }
            }
        }
    }
`;
